import { render } from "./kycForm.vue?vue&type=template&id=05fc37f2&lang=true"
import script from "./kycForm.vue?vue&type=script&lang=js"
export * from "./kycForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__